import { isPlatform } from '@ionic/react';
import { Keyboard } from '@capacitor/keyboard';
import * as React from 'react';
import { useEffect } from 'react';

export function useIsKeyBoardShown(): boolean {
  const [isKeyboardShown, setIsKeyboardShown] = React.useState<boolean>(false);

  useEffect(() => {
    if (!isPlatform('hybrid')) return;

    Keyboard.addListener('keyboardDidShow', () => {
      setIsKeyboardShown(true);
    });

    Keyboard.addListener('keyboardWillHide', () => {
      setIsKeyboardShown(false);
    });

    return () => {
      if (!isPlatform('hybrid')) return;

      Keyboard.removeAllListeners();
    };
  }, []);

  return isKeyboardShown;
}
